import React from 'react';
import './PhoneSystem.css';

import FlipCard from '../../../components/FlipCards/FlipCard';

const phoneSystem = ( props ) => {
	const card = {
		side1: 'Extensions',
		side2: '<p><strong>Pro Tip:</strong></p><p>Your extension number is always listed at the top of your phone display, next to the time.</p>',
		icon: 'communication.phonebook'
	}
	return (
		<section id="PhoneSystem">
			<div className="section">
			<FlipCard className="bg-gradient vertical invert" { ...card } />
				<div className="inner-section">
					<p>
						The Newport News, Centreville, and Pensacola office phone systems are connected, which means you can just dial someone's direct extension to reach them.
					</p>
					<p>
						There’s an ever-changing extension list circulating around offices, but the easiest way to reach someone is to use the phone book feature on your phone. Just press the book button and start spelling their first name with the number pad.
					</p>
				</div>
			</div>
		</section>
	);
};

export default phoneSystem;



// WEBPACK FOOTER //
// ./src/pages/Communication/PhoneSystem/PhoneSystem.js